<template>
  <div style="display: inline-block;">
    <b-btn
      v-b-tooltip.hover
      variant="none"
      title="Visualizar"
      class="btn-none rounded-pill m-0 icone-acao p-0"
      :disabled="gridProps.row.situacao === 'buscandodado'"
      @click="abrirArquivo(gridProps.row)"
    >
      <font-awesome-icon
        :icon="faExternalLinkAlt"
        class="text-primary"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      title="Observação"
      variant="none"
      class="btn-none rounded-pill m-0 icone-acao p-0"
      @click="openModalObservacao(gridProps.row)"
    >
      <font-awesome-icon
        :icon="faMessage"
        :class="{
          'text-success': todasObservacoesLidas,
          'text-warning': !todasObservacoesLidas && temObservacaoNova,
          'text-primary': !todasObservacoesLidas && !temObservacaoNova
        }"
      />
    </b-btn>
    <b-btn
      v-if="gridProps.row.situacao != 'Motivo'"
      v-b-tooltip.hover
      title="Enviar por e-mail"
      variant="none"
      class="btn-none icone-acao m-0 p-0"
      :disabled="gridProps.row.situacao === 'buscandodado'"
      @click="openModalEnviarCnd()"
    >
      <feather-icon
        icon="SendIcon"
        :class="gridProps.row.emailEnviado || emailEnviado ? 'text-success' : 'text-primary'"
        size="20"
      />
    </b-btn>
    <modal-whatsapp
      :tipo-rotina="`CND ${getTipoCnd()}`"
      :row="gridProps.row"
      :api="api"
    />

    <b-btn
      v-b-tooltip.hover
      variant="none"
      :title="`Histórico de CNDs ${getTipoCnd()}`"
      class="btn-none icone-acao m-0 p-0"
      @click="openModalHistorico(gridProps)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        class="text-primary"
      />
      <modal-historico
        :ref="`modalHistorico${gridProps.row.id}`"
        rotina="CND"
        :sub-rotinas="subRotinas"
        :des-de="dataLiberacaoHistorico"
        :filtros-rapidos="filtrosRapidos"
        :empresa="gridProps.row"
        :api="api"
        :tipo="tipo"
        :coluna-historico="colunaHistorico"
        :filtro-by-historico="['DataValidade', 'UltimaConsulta']"
      />
    </b-btn>

    <slot name="acao-custom" />

    <atualizacao-manual
      v-if="attManual"
      :title-tooltip="!abilityUpdate ? `Atualizar a CND ${getTipoCnd()}` : 'Usuário não possui permissão'"
      :exibir-modal="false"
      :tipo-rotina="`CND ${getTipoCnd()}`"
      :enviar-atualizacao="atualizarCnd"
      :disabled="abilityUpdate"
      @atualizar-grid="$emit('atualizar-grid')"
    />

    <modal-observacao
      ref="modalObservacao"
      v-model="gridProps.row"
      :tipo="tipoCnd"
      :api="api"
      :notificar="{ sucesso: notficarSucesso, erro: notificarErro }"
      @hidden="fecharObservacao($event)"
    />

    <envio-email
      ref="modalEnvioEmail"
      :title="`Enviar CND ${gridProps.row.razaoSocial}`"
      :sugestao="gridProps.row.emailEmpresa"
      :sugestao-email-adicional="gridProps.row.emailAdicionalEmpresa"
      @enviarEmail="enviarCnd"
    />

    <visualizar-arquivo
      v-if="mostarArquivo && arquivo.url"
      :url="arquivo.url"
      :observacao="arquivo.observacao"
      @hidden="fecharArquivo()"
    >
      <template v-slot:cabecalho-html>
        <slot
          name="cabecalho"
          :empresa-nome="empresaNome"
        />
      </template>

      <template v-slot:rodape-html>
        <slot
          name="rodape"
          :abrir-arquivo="abrirArquivoPendencia"
          :grid-row="gridProps.row"
          :fechar="fecharArquivo"
        />
      </template>
    </visualizar-arquivo>

    <pendencias
      v-if="mostrarPendencias"
      :empresa-id="situacaoFiscalSelecionada.situacaoFiscalId"
      :empresa-nome="situacaoFiscalSelecionada.razaoSocial"
      :grupos-existentes="situacaoFiscalSelecionada.tiposGrupoPendencias"
      @click-aqui="abrirArquivoPendencia(gridProps.row)"
      @hidden="fecharPendencias()"
    />

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :titulo-carregamento="'Aguarde!'"
      :descricao="'Estamos atualizando a CND ' + getTipoCnd() + '.'"
    />
  </div>
</template>

  <style lang="scss" scoped>
  .acoes-usuario {
    margin-right: 0.3rem;
    padding: 0.4rem;
  }
  .botoes-acao {
    padding: 0.5rem;
    padding-top: 0;
    padding-bottom: 0;
  }
  </style>

<script>
import {
  faExternalLinkAlt, faRefresh,
} from '@fortawesome/free-solid-svg-icons'
import {
  faMessage, faPaperPlane,
} from '@fortawesome/free-regular-svg-icons'
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@app/cnd-federal/shared/services/api'
import colunasHistorico from './shared/components/historico'

export default {
  components: {
    ModalWhatsapp: () => import('@/app/shared/components/whatsapp/ModalWhatsapp.vue'),
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    Pendencias: () => import('@app/situacao-fiscal/shared/components/pendencias/Pendencias.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    AtualizacaoManual: () => import('@/app/shared/components/botoes-inline/atualizacao-manual/AtualizacaoManual.vue'),
    ModalHistorico: () => import('@/app/shared/components/historico/ModalHistorico.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
    api: {
      type: Object,
      required: true,
    },
    tipoCnd: {
      type: String,
      default: '',
    },
    attManual: {
      type: Boolean,
      default: false,
    },
    maisInfoButton: {
      type: Function,
      default: null,
    },
    abilityUpdate: {
      type: Boolean,
      default: false,
    },
    filtrosRapidos: {
      type: Array,
      default: () => [],
    },
    dataLiberacaoHistorico: {
      type: String,
      default: null,
    },
    subRotinas: {
      type: String,
      default: null,
    },
    tipo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      faExternalLinkAlt,
      faMessage,
      faPaperPlane,
      faRefresh,
      mostarArquivo: false,
      arquivo: {},
      mostrarPendencias: false,
      situacaoFiscalSelecionada: null,
      empresaNome: '',
      isLoading: false,
      colunaHistorico: colunasHistorico,
      emailEnviado: false,
    }
  },
  computed: {
    temObservacaoNova() {
      return this.gridProps?.row?.temObservacoesNaoLidas ?? false
    },
    todasObservacoesLidas() {
      return this.gridProps?.row?.todasObservacoesLidas ?? false
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    openModalHistorico(props) {
      this.$refs[`modalHistorico${props.row.id}`].abrirModal()
    },
    getTipoCnd() {
      return this.tipoCnd === 'rfb' ? 'RFB/PGFN' : this.tipoCnd.toUpperCase()
    },
    abrirArquivo(documento) {
      this.api.getURL(documento.id)
        .then(payload => {
          this.arquivo.url = payload.data
          this.empresaNome = documento.razaoSocial
          this.mostarArquivo = true
        })
        .catch(err => {
          this.fecharArquivo()
          this.notificarErro('Não foi possível abrir a visualização de arquivo.', err)
          throw err
        })
    },
    fecharArquivo() {
      this.mostarArquivo = false
      this.arquivo = {}
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
    },
    // eslint-disable-next-line no-unused-vars
    abrirWhatsApp(row) {
      const url = 'https://wa.me/'
      window.open(url)
    },
    openModalObservacao() {
      this.$refs.modalObservacao.show()
    },
    fecharObservacao(observacaoNova) {
      this.gridProps.row.temObservacoesNaoLidas = observacaoNova.hasObservacaoNova
      this.gridProps.row.todasObservacoesLidas = observacaoNova.observacaoLida
    },
    enviarCnd(itens) {
      if (itens.emailsPara.length === 0 && itens.emailsCc === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Informe ao menos um e-mail',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        this.api
          .notificaCnd(this.gridProps.row.razaoSocial, itens.emailsPara, itens.emailsCc, this.gridProps.row.id, itens.mensagensAdicional, itens.definirEmailPadroes)
          .then(() => {
            this.notficarSucesso('Cnd enviada com sucesso')

            const mapRotinas = {
              rfb: { rotina: 1, registro: 1 },
              fgts: { rotina: 2, registro: 2 },
              trabalhista: { rotina: 3, registro: 3 },
              estadual: { rotina: 4, registro: 5 },
              municipal: { rotina: 10, registro: 6 },
              mte: { rotina: 16, registro: 4 },
            }

            const lookup = mapRotinas[this.tipoCnd.toLowerCase()]
            const tipoRotinaId = lookup ? lookup.rotina : 0
            const tipoRegistroId = lookup ? lookup.registro : 0

            if (tipoRotinaId > 0) {
              const payload = {
                tipoRotina: tipoRotinaId,
                tipoCanal: 0, // Email
                tipoRegistro: tipoRegistroId,
                idRegistro: this.gridProps.row.id,
                empresaId: this.gridProps.row.empresaId,
                destinatario: `${itens.emailsPara.join(';')}${itens.emailsCc ? `;${itens.emailsCc.join(';')}` : ''}`,
              }
              envioHistoricoApi.registrarManual(payload).catch(err => this.$erro(err))
            }
            this.emailEnviado = true
          })
          .catch(err => {
            this.notificarErro(err.message || 'Não foi possível enviar as notificações.')
            throw err
          })
      }
    },
    openModalEnviarCnd() {
      this.$refs.modalEnvioEmail.$refs.modalEnviarEmail.show()
    },
    temPendencia(row) {
      return row.tiposGrupoPendencias && row.tiposGrupoPendencias.length > 0
    },
    abrirPendencias(linha) {
      if (!this.temPendencia(linha)) {
        this.abrirArquivoFiscal(linha)
      } else if (!this.mostarArquivo && !this.mostrarPendencias) {
        this.situacaoFiscalSelecionada = linha
        this.mostrarPendencias = true
      }
    },
    abrirArquivoPendencia(linha) {
      this.mostarArquivo = false
      this.mostrarPendencias = false
      this.abrirArquivoFiscal(linha)
    },
    abrirArquivoFiscal(linha) {
      if (!this.mostarArquivo && !this.mostrarPendencias) {
        this.situacaoFiscalSelecionada = linha
        api.getURLSituacaoFiscal(this.situacaoFiscalSelecionada.situacaoFiscalId)
          .then(payload => {
            this.arquivo.url = payload.data
            this.mostarArquivo = true
          })
          .catch(err => {
            this.fecharArquivoFiscal()
            this.notificarErro('Não foi possível abrir a visualização de arquivo.', err)
            throw err
          })
      }
    },
    fecharArquivoFiscal() {
      this.mostarArquivo = false
      this.situacaoFiscalSelecionada = null
      this.arquivo = {}
    },
    fecharPendencias() {
      this.mostrarPendencias = false
      this.situacaoFiscalSelecionada = null
    },
    atualizarCnd() {
      return api.updateCnd(this.gridProps.row.empresaId, this.tipoCnd.replace('/', '').toLowerCase())
    },
  },
}
</script>
